import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TextExpander from 'src/app/components/TextExpander';
import AgreementComponent from 'src/app/components/AgreementComponent';
import {
  accountFormAgreementsMarketingGet,
  accountFormAgreementsMarketingToggle
} from 'src/app/redux/actions/registration/account/accountFormAgreementsMarketing';
import agreementPropType from 'src/app/propTypes/agreement';
import 'src/app/containers/Registration/Account/AccountFormAgreementsMarketingContainer.scss';


const marketingCopy =
  <span>
    Kiedy założysz konto Pracuj.pl, możesz cofnąć każdą zgodę w ustawieniach swojego konta (zakładka Prywatność).
  Pamiętaj, że oceniamy Twoje preferencje i zainteresowania w celu dopasowania naszych komunikatów marketingowych,
  na podstawie naszego uzasadnionego interesu i jeżeli nie chcesz, abyśmy tak działali, możesz złożyć sprzeciw.
  Instrukcję jak cofnąć zgodę lub złożyć sprzeciw znajdziesz w{' '}
    <a styleName="marketing-agreements__about-link"
       href="//grupapracuj.pl/polityka-prywatnosci/"
       target="_blank"
       rel="noopener noreferrer"
    >
      Polityce Prywatności
    </a>
  </span>;

class AccountFormAgreementsMarketingContainer extends React.PureComponent {

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(accountFormAgreementsMarketingGet());
  }

  toggleCheckbox = (code) => {
    const { dispatch } = this.props;

    dispatch(accountFormAgreementsMarketingToggle({ code }));
  };


  render() {
    const { toggleCheckbox } = this;
    const { agreements, sending } = this.props;

    const primaryText = <span>
      Wszystkie poniższe zgody udzielam Pracuj.pl. W dowolnym momencie, mam prawo cofnąć każdą z nich.
    </span>;

    return (
      <div className="marketing-agreements">
        <div styleName="marketing-agreements__about">
          <TextExpander
            primaryText={ primaryText }
            secondaryText={ marketingCopy }
          />
        </div>

        {
          !!agreements.length &&
          agreements
            .map((agreement) => <AgreementComponent
              disabled={ sending }
              key={ `agreement-${agreement.code}` }
              agreement={ agreement }
              toggle={ toggleCheckbox }
            />)
        }

      </div>
    );
  }
}

AccountFormAgreementsMarketingContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  agreements: PropTypes.arrayOf(agreementPropType).isRequired,
  sending: PropTypes.bool.isRequired
};

const mapStateToProps = (store) => ({
  ...store.accountFormAgreementsReducer,
  sending: store.accountFormReducer.sending
});

export default connect(mapStateToProps)(AccountFormAgreementsMarketingContainer);
